export default __webpack_public_path__ + "static/wood1-0f6d555c62e023d4396352425213aa92.png";